import { createContext, useContext, useState, useEffect, useRef } from "react";
import { Box, Typography, Divider, Skeleton, useMediaQuery, Button, CircularProgress, IconButton, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Card, CardMedia } from "@mui/material";
import { Container } from "react-bootstrap";
import PlotStatusCard from "./PlotdetailstatusCard";
import theme from "../../utils/theme";
import PLotsLoaction from "./plot_location";
import PlotDocumentSection from "./document_section";
import BreadcrumbsNav from "../../components/common/BreadCrumbNav";
import { useParams, useNavigate } from "react-router-dom";
import { get_market_property, get_settings } from "../../api/ControllApi";
import { useCallback } from "react";
import { toast } from "react-toastify";
import { plot_enquiry_property_url } from "../../api/ControllApi";
import { useUser } from "../../context/LoginDetail";
import { useModal } from "../../context/ModalContext";
import GiooPlotsLocation from '../GIOO_Plots/GiooPlotsLocation'
import ImageViewerCard from "../GIOO_Plots/GiooimageViwerCard";
import HomeIcon from "@mui/icons-material/Home";
import ResdentialImageView from "../Residential_Properties/ResidentialImageView";
import PlotMap from "./PlotMap";
import { ASSET_BASE } from "../../utils/baseUrls";
import Slider from "react-slick";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

/* CUSTOM ARROWS FOR SLIDER */
function NextArrow({ onClick }) {
  return (
    <Box
      onClick={onClick}
      sx={{
        position: "absolute",
        right: { xs: "-10px", md: "-25px" },
        top: "50%",
        transform: "translateY(-50%)",
        cursor: "pointer",
        zIndex: 5,
        bgcolor: "#fff",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        p: 0.5
      }}
    >
      <img src="/assets/images/right_arrow.png" alt="next" width={30} />
    </Box>
  );
}

function PrevArrow({ onClick }) {
  return (
    <Box
      onClick={onClick}
      sx={{
        position: "absolute",
        left: { xs: "-10px", md: "-25px" },
        top: "50%",
        transform: "translateY(-50%)",
        cursor: "pointer",
        zIndex: 5,
        bgcolor: "#fff",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        p: 0.5
      }}
    >
      <img src="/assets/images/left_arrow.png" alt="prev" width={30} />
    </Box>
  );
}



export default function PlotMarketDetails() {

  const { id } = useParams()
  const [plotDetails, setPlotDetails] = useState(null);
  const [description, setDescription] = useState()
  const isMobile = useMediaQuery("(max-width:600px)");
  const [loading, setLoading] = useState(false)
  const [settings, setSettings] = useState(null);
  const navigate = useNavigate();


  const [documentVerified, setDocumentVerified] = useState();
  const [documents, setDocuments] = useState([]);
  const [queryloading, setQueryLoading] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [enquired, setEnquired] = useState(false);
  const { requireLogin } = useModal();

  const { user } = useUser();


  const [expanded, setExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    if (textRef.current) {
      const overflows =
        textRef.current.scrollHeight > textRef.current.clientHeight;
      setIsOverflowing((prev) => (prev !== overflows ? overflows : prev));
    }
  }, [description]);


  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    quote: "",
    plot_id: id,
    plot_type: "",
  });


  const BASE_URL = ASSET_BASE.replace(/\/$/, "");



  const get_plot_market_data = () => {
    setLoading(true)
    get_market_property(id)
      .then((res) => {
        setPlotDetails(res?.data);
        setDocuments(res?.data?.documents || []);
        setDescription(res?.data.description || "")

      })
      .catch((err) => {

      })
      .finally(() => {
        setLoading(false)
      })
  }





  const formatDate = (dateStr) => {
    if (!dateStr) return "-";

    const d = new Date(dateStr);

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const formatPrice = (num) => {

    if (!num) return "-";
    num = Number(num);

    if (num >= 10000000) return (num / 10000000).toFixed(2) + " Cr";
    if (num >= 100000) return (num / 100000).toFixed(2) + " Lakhs";
    if (num >= 1000) return (num / 1000).toFixed(2) + " K";

    return num.toString();
  };




  useEffect(() => {
    get_plot_market_data();
    get_settings().then(res => setSettings(res?.data || null));
  }, [])




  const handleQuery = async () => {
    const { name, phone } = user;

    if (!name || !phone) {
      toast.error("Please fill all fields");
      return;
    }

    setQueryLoading(true);

    try {
      // Prepare the payload
      const user = {
        // name: name,
        property_id: plotDetails?.id,
        // plot_type: plotDetails?.type,
        // phone: phone,
        // message: 'test', 
      };

      // Call the API with the payload
      const res = await plot_enquiry_property_url(user);


      if (res?.status === true) {
        toast.success("Enquiry submitted successfully!");
        setEnquired(true);
      } else if (res?.status === false && res?.code === 409) {
        toast.info(res?.data?.message || "You have already enquired");
        setEnquired(true);
      } else {
        toast.error(res?.data?.message || "Something went wrong");
      }
    } catch (error) {


      const errMsg =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to submit enquiry";

      toast.error(errMsg);
    }

    setQueryLoading(false);
  };


  const safeLat =
    plotDetails?.lat && !isNaN(plotDetails.lat)
      ? plotDetails.lat
      : 0;

  const safeLng =
    plotDetails?.long && !isNaN(plotDetails.long)
      ? plotDetails.long
      : 0;

  const hasValidLocation = safeLat !== 0 && safeLng !== 0;


  return (
    <Container sx={{ py: 5, mt: 5 }}>
      <Box sx={{ mb: 3, mt: 5 }}>
        <BreadcrumbsNav />
      </Box>
      <Box
        sx={{
          position: "relative",
          backgroundImage: `url(/assets/images/plootbg.png)`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          my: 5,
          p: { xs: 2, sm: 3, md: 4 },
          borderRadius: "16px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
        }}
      >
        {/* MAIN LAYOUT */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", lg: "row" },
            gap: { xs: 3, md: 4 },
            alignItems: "stretch",
          }}
        >
          {/* LEFT: IMAGE CARD */}
          <Box
            sx={{
              position: "relative",

              p: 1,
              borderRadius: "12px",
              width: { xs: "100%", lg: "40%" },
              overflow: "visible",
              minHeight: 250,

            }}
          >

            {plotDetails?.verify_status == 1 && <Box
              component="img"
              src="/assets/images/approved.png"
              alt="approved"
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: { xs: 80, md: 110 },
                zIndex: 10,
                transform: "translate(-22px, -22px) rotate(-15deg)",
                pointerEvents: "none",
              }}
            />}
            <PlotStatusCard
              title={plotDetails?.name || " "}
              loading={loading}
              imageUrl={plotDetails?.image || "/assets/images/plot-1.png"}
              approved={true}
              whatsappNumber={settings?.whatsapp}
              youtubeLink={plotDetails?.youtube_link}
            />

          </Box>


          <Box
            sx={{
              flexGrow: 1,
              //   backgroundColor: "rgba(255,255,255,0.7)",
              //   backdropFilter: "blur(8px)",
              p: { xs: 2, sm: 3 },
              borderRadius: "16px",
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            {/* ROW 1 */}
            <ResponsiveRow>
              <InfoBlock
                icon="/assets/images/crown.png"
                title="Project Name"
                loading={loading}
                value={
                  plotDetails ? (
                    plotDetails.name
                  ) : (
                    <Skeleton variant="text" width={50} />
                  )
                }
              // value={plotDetails ? plotDetails?.name : ""}
              />
              <InfoBlock
                icon="/assets/images/loca.png"
                title="Location"
                loading={loading}
                value={plotDetails ? plotDetails?.address : ""}
              />
            </ResponsiveRow>

            <Divider />

            {/* ROW 2 */}
            <ResponsiveRow>
              <InfoBlock
                icon="/assets/images/markplot.png"
                title="Plot Type"
                loading={loading}
                value={plotDetails?.property_type?.category_name ?? "—"}
              />
              <InfoBlock
                icon="/assets/images/area.png"
                title="Plot Area"
                loading={loading}
                value={
                  plotDetails?.area
                    ? `${plotDetails.area} Sq ft`
                    : "—"
                }
              />
            </ResponsiveRow>


            <Divider />

            {/* ROW 3 */}
            <ResponsiveRow>
              <InfoBlock
                icon="/assets/images/pricetag.png"
                loading={loading}
                title="Total Price"
                value={formatPrice(plotDetails?.price)}
              />
              <InfoBlock
                icon={plotDetails?.verify_status == "1" ? "/assets/images/verified.png" : "/assets/icons/not_verified.png"}
                loading={loading}
                title="Verification"
                value={plotDetails ? plotDetails?.verify_status == "1" ? "Verified Plot" : "Not verified" : ""}
              />
            </ResponsiveRow>

            <Divider />

            {/* ROW 4 */}
            <ResponsiveRow>
              <InfoBlock icon="/assets/images/calender.png" title="Posted On" value={formatDate(plotDetails?.created_at)} loading={loading} />
              <InfoBlock icon="/assets/images/calender.png" title="Updated On" value={formatDate(plotDetails?.updated_at)} loading={loading} />
            </ResponsiveRow>

            <Divider />

            <ResponsiveRow>
              <InfoBlock
                icon="/assets/images/count.png"
                title="Plot Count"
                loading={loading}
                value={plotDetails?.plot_count ?? "—"}
              />
            </ResponsiveRow>

            <Divider />


            <center>
              <Button
                sx={{
                  padding: "8px 40px",
                  borderRadius: "22px",
                  backgroundColor: theme.palette.secondary.main,
                  color: "black",
                  fontWeight: 600,
                  minHeight: 40,
                  "&:disabled": {
                    backgroundColor: theme.palette.secondary.main,
                    color: "black",
                  },
                }}
                onClick={() => requireLogin(() => setConfirmOpen(true))}
                disabled={queryloading || enquired || plotDetails?.sold_status === 1}
              >
                {queryloading ? (
                  <CircularProgress
                    size={20}
                    thickness={5}
                    sx={{
                      color: "black",
                    }}
                  />
                ) : plotDetails?.sold_status === 1 ? (
                  "Sold Out"
                ) : enquired ? (
                  "Enquired"
                ) : (
                  "Send Enquiry"
                )}
              </Button>

              {/* CONFIRM POPUP */}
              <Dialog
                open={confirmOpen}
                onClose={() => setConfirmOpen(false)}
                maxWidth="xs"
                fullWidth
              >
                <DialogTitle>Confirm Enquiry</DialogTitle>

                <DialogContent>
                  <Typography>
                    Are you sure you want to send this enquiry?
                  </Typography>
                </DialogContent>

                <DialogActions>
                  <Button variant="outlined" onClick={() => setConfirmOpen(false)}>
                    No
                  </Button>

                  <Button
                    variant="contained"
                    sx={{ bgcolor: "#6BAF4B" }}
                    onClick={() => {
                      setConfirmOpen(false);
                      handleQuery();
                    }}
                  >
                    Yes
                  </Button>
                </DialogActions>
              </Dialog>
            </center>
          </Box>
        </Box>
      </Box>


      {description && <div>
        <Box
          sx={{
            mt: 4,
            // mb: 3,
            background: "#608900",
            color: "#fff",
            px: 2,
            py: 1,
            width: "fit-content",
            borderRadius: "8px 8px 0 0",
            fontWeight: 500,
          }}
        >
          Description
        </Box>

        <Box
          sx={{
            mt: 0,
            mb: 4,
            p: isMobile ? 2 : 3,
            background: "#fff",
            borderRadius: 3,
            boxShadow: 2,
          }}
        >
          <Typography
            ref={textRef}
            sx={{

              whiteSpace: "pre-line",
              display: "-webkit-box",
              WebkitLineClamp: expanded ? "none" : 4,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >

            {"\n"}
            {description || ""}
          </Typography>

          {isOverflowing && (
            <Button
              size="small"
              onClick={() => setExpanded(!expanded)}
              sx={{ mt: 1, textTransform: "none" }}
            >
              {expanded ? "Show less" : "Show more"}
            </Button>
          )}
        </Box>
      </div>}

      <Box sx={{ my: 4 }}>
        <GiooPlotsLocation
          address={plotDetails?.address}
          loading={loading}
          uldNumber={plotDetails?.uld_no}
          amenity={plotDetails?.aminities ?? plotDetails?.amenities ?? plotDetails?.amenity ?? []}
          nearbyLoction={plotDetails?.nearbyLocations}
          commonfacility={plotDetails?.commonfacility}
        />

      </Box>

      {/* GREENHEAP PLOTS BLUEPRINT + 3D IMAGE */}
      <Box
        sx={{
          mt: 6,
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: { xs: 2.5, md: 4 },
          width: "100%",
        }}
      >
        {/* BLUEPRINT */}
        <Box sx={{ flex: 1, height: { xs: 260, sm: 300, md: 420 } }}>
          <ResdentialImageView
            image={plotDetails?.plot_image || "/assets/images/plot_image.png"}
            viewerId="blueprint-viewer"
            title="GreenHeap Plots Layout Sketch"
            variant="blueprint"
          />
        </Box>

        {/* 3D IMAGE */}
        <Box sx={{ flex: 1, height: { xs: 260, sm: 300, md: 420 } }}>
          <ResdentialImageView
            image={plotDetails?.three_d_image || plotDetails?.plot_image || "/assets/images/plot_image.png"}
            viewerId="threed-viewer"
            title="Aerial View"
            variant="blueprint"
          />
        </Box>
      </Box>

      {/* MAP */}
      <Box
        sx={{
          mt: 5,

          width: "100%",
          height: 400,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography fontWeight={600} mb={1} color="#608900">
          LOCATION:
        </Typography>

        <Box
          sx={{
            flex: 1,
            borderRadius: 3,
            overflow: "hidden",
            border: "1px solid #e0e0e0",
            bgcolor: "#f5f5f5",
          }}
        >
          <PlotMap
            lat={plotDetails?.lat}
            lng={plotDetails?.long}
            map_set={plotDetails?.map_set}
            propertyName={plotDetails?.name}
            showRadius={["Plot", "Land"].includes(plotDetails?.property_type?.category_name)}
          />
        </Box>
      </Box>

      <Box sx={{ my: 7 }}>
        {/* <PlotDocumentSection handlePayment={handlePayment} documents={documents} documentVerified={true}/> */}
      </Box>
    </Container>
  );
}



function ResponsiveRow({ children }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        gap: 2,
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      {children}
    </Box>
  );
}

function InfoBlock({ icon, title, value, loading }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, flex: 1 }}>
      {loading ? <Skeleton width={30} height={48} /> : <img src={icon} height={30} alt="" />}
      <Box>
        {loading ? (
          <>
            <Skeleton width={80} height={18} />
            <Skeleton width={100} height={18} />
          </>
        ) : (
          <>
            <Typography
              sx={{
                color: theme.palette.primary.main,
                fontWeight: 600,
                fontSize: 14,
              }}
            >
              {title}
            </Typography>
            <Typography sx={{ fontSize: 14 }}>
              {value || "-"}
            </Typography>
          </>
        )}
      </Box>
    </Box>
  );
}

function DateInfo({ label, date }) {
  return (
    <Box sx={{ flex: 1 }}>
      <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
        <img src="/assets/images/calender.png" height={22} alt="" />
        <Box>

          <Typography sx={{ fontSize: 14 }}>{date}</Typography>
          <Typography sx={{ fontSize: 12, opacity: 0.7 }}>{label}</Typography>
        </Box>
      </Box>

    </Box>
  );
}